import { render, staticRenderFns } from "./NoteDetail.vue?vue&type=template&id=40ecf6f8&scoped=true&"
import script from "./NoteDetail.vue?vue&type=script&lang=js&"
export * from "./NoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetail.vue?vue&type=style&index=0&id=40ecf6f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecf6f8",
  null
  
)

export default component.exports